
import { OperatorSummary } from "@/api/dtos/Station.schema";
import { deepClone } from "@/misc/helpers";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";
import EditActionButtons from "../EditActionButtons.vue";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton,
    EditActionButtons,
  },
})
export default class OperatorChooser extends Vue {
  @Prop()
  operators!: OperatorSummary[];

  @Prop({
    default: null,
  })
  currentOperator!: OperatorSummary | null;

  selectedOperator: string | null = null;

  @Watch("currentOperator")
  onOperatorsChanged(): void {
    this.initializeWidget();
  }

  mounted(): void {
    this.initializeWidget();
  }

  initializeWidget(): void {
    this.selectedOperator = this.currentOperator!.uuid;
  }

  get operatorSelectItems(): {
    text: string;
    value: string;
  }[] {
    return this.operators.map((operator) => {
      return {
        text: operator.name,
        value: operator.uuid,
      };
    });
  }

  $refs!: {
    editFrame: EditFrame;
  };
  isEditing = false;

  onSave(): void {
    this.$emit(
      "save",
      this.operators.find((o) => o.uuid === this.selectedOperator)
    );
  }

  onCancel(): void {
    this.selectedOperator = this.currentOperator!.uuid;
  }
}
